import { useTranslation } from "react-i18next";

interface TranslatedItemProps {
  title: string; // Pass a i18n translation key
}

export const TranslatedItem = ({ title }: TranslatedItemProps) => {
  const { t } = useTranslation();

  return <p>{t(`${title}`)}</p>;
};
